import React from 'react';
import TicketRow from "./ticketRow";
import {useCollapse} from 'react-collapsed'
import {inject} from "mobx-react";

function Category({DeviceStore, category, tickets, chooseSeats, chooseVariants}){

  const {locale, defaultLocale, popup} = DeviceStore;

  const { getCollapseProps, getToggleProps, isExpanded } = useCollapse({
    defaultExpanded: typeof window['cat_hidden_'+category.id] === 'undefined' ? !category.collapsed : !window['cat_hidden_'+category.id],
    onCollapseStart: () => {
      window['cat_hidden_'+category.id] = true;
  },
    onExpandEnd:() =>{
      window['cat_hidden_'+category.id] = false;
    }
  })

  const name = category.name[locale] ?? (category.name[defaultLocale] ?? category.name);
  const description = category.description[locale] ?? (category.description[defaultLocale] ?? null);

  const cart = popup && category.collapsed;

  const hasSelectedTickets = DeviceStore.selectedTickets.filter(t => tickets.map(t => t.id).includes(t.tickettype_id)).length > 0;

  return (
      <div className="card">
        {!cart ? <div {...getToggleProps()} className={"p-4 md:p-6 md:py-4 flex justify-between transition items-center bg-gray-100 dark:bg-gray-800 " + (isExpanded ? '' : ' bg-gray-50 dark:bg-gray-800')}>
          <div>
            <h4 className="text-lg text-gray-900 font-bold dark:text-gray-200">{name}</h4>
            <p className="text-xs text-gray-600 dark:text-gray-400 pr-10" style={{whiteSpace: 'pre-line'}}>{description}</p>
          </div>
          <div className="cursor-pointer dark:text-gray-200">
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={3} stroke="currentColor" className={"w-4 h-4 transition-transform " + (isExpanded ? ' rotate-180' : '')}>
              <path strokeLinecap="round" strokeLinejoin="round" d="M19.5 8.25l-7.5 7.5-7.5-7.5"/>
            </svg>

          </div>
        </div> : <div className="p-4 md:p-6 md:py-4 bg-gray-100 flex justify-between items-center dark:bg-gray-800 dark:border-gray-700 dark:text-gray-200">
          <div>
            <h4 className="text-lg text-gray-900 font-bold dark:text-gray-200">{name}</h4>
            <p className="text-xs text-gray-600 dark:text-gray-400" style={{whiteSpace: 'pre-line'}}>{description}</p>
          </div>

        </div>}
        <div {...getCollapseProps()}>
          <div className="border-t dark:border-gray-800">
            {tickets.map((ticket, i) => <TicketRow last={i === tickets.length - 1} key={ticket.id} chooseSeats={chooseSeats} chooseVariants={chooseVariants} ticket={ticket} category={category}/>)}
          </div>
        </div>
        {cart && !hasSelectedTickets ? <div className="p-4 text-xs text-gray-600 dark:text-gray-400 border-b dark:border-gray-700">Geen tickets gekozen.</div> : null}
      </div>
  )
}

export default inject('DeviceStore')(Category);
